export default __webpack_public_path__ + "static/media/320.ef5f702a.jpg";